import { ChangeDetectionStrategy, Component } from '@angular/core';

interface QuickOrderLinkData {
  linkName: string;
  url: string;
  target?: string;
}

@Component({
  selector: 'gen-quick-order-link',
  templateUrl: './quick-order-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenQuickOrderLinkComponent {

  data: QuickOrderLinkData = {
    linkName: 'Quick Order',
    url: '/my-account/quick-order',
    target: '_self',
  };
}